import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, finalize, Subscription } from 'rxjs';
import { Helper } from '../../utilities/classes/helper.class';

@Component({
  selector: 'app-acc-auto-complete-input',
  templateUrl: './acc-auto-complete-input.component.html',
  styleUrls: ['./acc-auto-complete-input.component.scss']
})
export class AccAutoCompleteInputComponent implements OnInit {

  @Input({ alias: 'formControlAttr', required: true }) formControlAttr!: FormControl;
  @Input({ alias: 'formGroupAttr', required: true }) formGroupAttr!: FormGroup;

  @Input({ alias: 'placeHolder' }) placeHolder: string = '';
  @Input({ alias: 'className' }) className: string = '';

  @Input({ alias: 'label' }) label: string = '';
  @Input({ alias: 'labelClass' }) labelClass: string = '';
  @Input({ alias: 'invalidMessage' }) invalidMessage: string = '';
  @Input({ alias: 'invalidMessageClass' }) invalidMessageClass: string = '';

  @Input({ alias: 'options', required: true }) options?: string[] | null = [];

  public readonly optionList$ = new BehaviorSubject<string[]>([]);

  public ngOnInit(): void {
    this.optionList$.next(this.options ?? []);

    const subs: Subscription = this.formControlAttr.valueChanges.pipe(finalize(() => subs.unsubscribe())).subscribe(val => this.onChange(val));
  }

  public onChange(value: string) {
    const filteredOptions = this.options?.filter(opt => Helper.string.trimLowerCase(opt).includes(Helper.string.trimLowerCase(value))) ?? this.options ?? [];
    this.optionList$.next(filteredOptions);
  }
}
